import React from "react";

export default function RiskMeter({ risk, compact = false }) {
  if (!risk) return null;
  const pct = risk.percent || 0;
  const color = pct >= 70 ? "#8B5E5E" : pct >= 45 ? "#E2B77B" : pct >= 20 ? "#C5A566" : "#7B9D7E";
  const label = { baixo: "Baixo", moderado: "Moderado", alto: "Alto", critico: "Critico" }[risk.level] || risk.level;

  if (compact) {
    return (
      <div className="inline-flex items-center gap-2" data-testid="risk-meter-compact">
        <span className="text-[10px] tracking-widest uppercase" style={{ color }}>{label}</span>
        <div className="h-1.5 w-16 bg-[#EBE5DF]">
          <div className="h-full" style={{ width: `${pct}%`, background: color }} />
        </div>
        <span className="text-xs tabular font-bold" style={{ color }}>{pct}%</span>
      </div>
    );
  }

  return (
    <div className="border border-[#EBE5DF] bg-white p-5" data-testid="risk-meter">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] tracking-widest uppercase text-[#5C5A57]">Previsao de calote</div>
        <div className="text-[10px] tracking-widest uppercase font-bold" style={{ color }}>{label}</div>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="font-display text-4xl font-bold tabular" style={{ color }}>{pct}%</span>
        <span className="text-xs text-[#5C5A57]">chance de atraso</span>
      </div>
      <div className="h-2 bg-[#EBE5DF] mt-3 overflow-hidden">
        <div className="h-full transition-all" style={{ width: `${pct}%`, background: color }} />
      </div>
      <details className="mt-3 pt-3 border-t border-[#EBE5DF]">
        <summary className="text-[10px] tracking-widest uppercase text-[#5C5A57] cursor-pointer">Sinais</summary>
        <div className="mt-2 grid grid-cols-2 gap-1 text-xs text-[#5C5A57]">
          <div>Score: <strong>{risk.features.score}</strong></div>
          <div>Pago em dia: <strong>{risk.features.on_time_payments}</strong></div>
          <div>Atrasos: <strong>{risk.features.late_payments}</strong></div>
          <div>Med. dias atraso: <strong>{risk.features.avg_days_late}</strong></div>
          <div>Parcelas vencidas: <strong>{risk.features.open_late_installments}</strong></div>
          <div>Uso do limite: <strong>{risk.features.limit_usage_pct}%</strong></div>
        </div>
      </details>
    </div>
  );
}
